module.exports = __webpack_public_path__ + "static/media/gertner-vinobrani-02.cdf94b25.png";